import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { PackageInfoIcon } from 'shared-widget-components/src/components/Icons';
import { useWineContentInfo } from '../hooks/useWineContentInfo';
import { WinePackageWidgetModel } from 'shared-widget-components/src/services/FeaturedPackagesService';

interface WinePackageContentProps {
  winePackage: WinePackageWidgetModel;
  isShowContent: boolean;
}

/**
 * The WinePackageContent component renders the content of a wine package.
 * @param winePackage - The wine package to render.
 * @param isShowContent - The boolean value to show the content of the wine package.
 * @returns The WinePackageContent component is returning JSX elements.
 */

export const WinePackageContent = ({ winePackage, isShowContent }: WinePackageContentProps) => {
  const { tooltipContent, handleIconHover, handleIconLeave } = useWineContentInfo({ winePackage });

  const { t } = useTranslation();

  return (
    <div className='flex h-[23px] items-center'>
      <p className='min-[350px]:text-[12px] md:text-[14px] text-black mr-[8px]'>
        {winePackage.content.length} {t('winePackageWidget.bottle')}
      </p>
      {isShowContent && (
        <>
          <div
            data-tooltip-id={winePackage.id.toString()}
            data-tooltip-html={tooltipContent}
            className='pt-[2px]  text-gray-600 flex items-center min-[350px]:mr-0 sm:mr-[16px] w-fit h-full '
            onMouseEnter={handleIconHover}
            onMouseLeave={handleIconLeave}
          >
            <PackageInfoIcon />
          </div>
          <Tooltip id={winePackage.id.toString()} place='top' className='w-fit' />
        </>
      )}
    </div>
  );
};
